import { useState, useEffect } from "react"
import { LangugeContext } from "./LangugeContext"
import "./main.css"
import { useParams } from 'react-router-dom';
import { language_ch, language_en } from "./language"

export default function TrackVideo(props) {

    let { language } = useParams()
    if (!language) {
        language = "ch"
    }
    var languagePackage = language === "ch" ? language_ch : language_en

    return (
        <LangugeContext.Provider value={{ language, languagePackage }} >
            <div
                class="w-full h-full overflow-auto container p-5"
            >
                <img src="https://osscn.app.feiyu-tech.com/gif/track-recording.gif" />

                <p className=" text-gray-600 mt-5 text-sm">
                    {languagePackage.RegisterNewUserPrompt.UsageTips}<br /><br />
                    {languagePackage.TrackVideo.UsageTips_1}<br /><br />
                    {languagePackage.TrackVideo.UsageTips_2}<br /><br />
                    {languagePackage.TrackVideo.UsageTips_3}<br />
                </p>

                
            </div>
        </LangugeContext.Provider>
    )
}